const digest = 'abd1b30170f24a06074ab2de26f252bc078c406ef487c9183270f7235f4d2240';
const css = `._inputWrapper_d1ggk_1:focus-within input{max-width:calc(100% - 2.75rem)}._inputField_d1ggk_5>div{margin-top:0}._clearButton_d1ggk_9{height:2.75rem!important;min-height:2.75rem!important;min-width:2.75rem!important;right:3px;width:2.75rem!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'inputWrapper': '_inputWrapper_d1ggk_1', 'inputField': '_inputField_d1ggk_5', 'clearButton': '_clearButton_d1ggk_9' };
export const inputWrapper = '_inputWrapper_d1ggk_1';
export const inputField = '_inputField_d1ggk_5';
export const clearButton = '_clearButton_d1ggk_9';
export { css, digest };